import {
    Calendar,
    Clock,
} from "lucide-react";

function DashboardStats({

    upcomingCount,
    totalHours,

}) {

    const stats = [

        {
            label:
                "Upcoming Bookings",

            value:
                upcomingCount,

            icon:
                Calendar,
        },

        {
            label:
                "Hours Played",

            value:
                `${totalHours}h`,

            icon:
                Clock,
        },
    ];

    return (

        <div style={styles.grid}>

            {stats.map(

                (
                    stat,
                    index
                ) => {

                    const Icon =
                        stat.icon;

                    return (

                        <div
                            key={index}
                            style={styles.card}
                        >

                            <div style={styles.iconBox}>

                                <Icon
                                    size={24}
                                />

                            </div>

                            <div style={styles.value}>
                                {stat.value}
                            </div>

                            <div style={styles.label}>
                                {stat.label}
                            </div>

                        </div>
                    );
                }
            )}

        </div>
    );
}

const styles = {

    grid: {

        display: "grid",

        gridTemplateColumns:
            "repeat(auto-fit, minmax(280px, 1fr))",

        gap: "20px",

        marginBottom: "24px",
    },

    card: {

        background:
            "rgba(0,40,70,0.72)",

        padding: "24px",

        borderRadius: "24px",

        border:
            "1px solid rgba(0,255,136,0.15)",

        backdropFilter:
            "blur(10px)",

        boxShadow:
            "0 10px 30px rgba(0,0,0,0.18)",
    },

    iconBox: {

        width: "52px",

        height: "52px",

        borderRadius: "14px",

        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        background:
            "rgba(0,255,136,0.12)",

        color: "#00ff88",

        marginBottom: "16px",
    },

    value: {

        color: "#fff",

        fontSize: "34px",

        fontWeight: "800",

        marginBottom: "6px",
    },

    label: {

        color: "#cbd5e1",

        fontSize: "14px",

        fontWeight: "500",
    },
};

export default DashboardStats;